<template>
  <div class="mb-4">
    <label v-if="label" class="block text-sm font-semibold mb-2 text-black">
      {{ label }}
      <span v-if="required" class="text-red-600">*</span>
    </label>

    <input
      v-if="type !== 'textarea'"
      :type="type"
      :placeholder="placeholder"
      :value="modelValue"
      :required="required"
      class="form-input"
      @input="$emit('update:modelValue', $event.target.value)"
    />

    <textarea
      v-else
      :placeholder="placeholder"
      :value="modelValue"
      :required="required"
      class="form-input"
      rows="4"
      @input="$emit('update:modelValue', $event.target.value)"
    />

    <p v-if="error" class="text-red-600 text-sm mt-1">{{ error }}</p>
  </div>
</template>

<script setup>
defineProps({
  label: String,
  placeholder: String,
  type: {
    type: String,
    default: 'text'
  },
  modelValue: [String, Number],
  required: Boolean,
  error: String
})

defineEmits(['update:modelValue'])
</script>
